export const primaryTitle = "المنصه الإلكترونيه";
export const secondaryTitle = "لتسجيل المستحضرات البيطريه";
export const infoText =
  "المنصه تساعد علي التواصل بين الإداره العامه للمستحضرات البيطريه والشركات العامله بمجال الأدويه البيطريه و الإدارات ذات الصله بهيئة الدواء المصريه لتيسير وإسراع اجراءات تسجيل مستحضرات بيطريه أمنه وفعاله وعالية الجوده";
export const loginEDAText = "Login As An EDA Member";
export const loginCompanyText = "Login As A Company";
